"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassiveBuffEffectHandler = exports.PassiveBuffEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class PassiveBuffEffectArgs {
    constructor(name, metaText, buff) {
        this.name = name;
        this.metaText = metaText;
        this.buff = buff;
        this.__type = EffectType_1.EffectType.PassiveBuff;
        this.__typeName = "PassiveBuff";
        this.harmful = false;
    }
}
exports.PassiveBuffEffectArgs = PassiveBuffEffectArgs;
let PassiveBuffEffectHandler = class PassiveBuffEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        const effect = state.args.buff;
        container.selectLivingTargets(state.targetId, Target_1.Target.AllAllies)
            .forEach(allyId => container.applyBuff({
            sequence,
            creatorId: state.targetId,
            targetId: allyId,
            effect,
            duration: Duration_1.Duration.Permanent,
            supernatural: true
        }));
        state.meta.eventHandlerIds = [
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.AllyResurrected, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAllyResurrected", {
                applyTo: "resurrected",
                effects: [
                    {
                        effect,
                        duration: Duration_1.Duration.Permanent,
                        supernatural: true,
                    }
                ]
            }),
        ];
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.eventHandlerIds.forEach(ehId => container.cancelEventHandler(ehId));
        // since the effects can be added from an event handler script, we need to manually search for them and remove them
        // TODO: support linking effects
        container.selectLivingTargets(state.targetId, Target_1.Target.AllAllies)
            .flatMap(allyId => container.getEffectsOfType(allyId, state.args.buff.__type))
            .filter(effectId => { var _a; return ((_a = container.getEffect(effectId)) === null || _a === void 0 ? void 0 : _a.creatorId) === state.targetId; })
            .forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
PassiveBuffEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.PassiveBuff)
], PassiveBuffEffectHandler);
exports.PassiveBuffEffectHandler = PassiveBuffEffectHandler;
